import React, { CSSProperties } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import "./footer.css";
import { ReactComponent as ArrowRight } from "./arrow-right.svg";
import { ReactComponent as HeLogo } from "../../assets/logo_he.svg";
import { ReactComponent as EnLogo } from "../../assets/logo_en.svg";
import { ContactUsModal } from "../ContactUs/ContactUsModal";
import { ContactUsSuccessModal } from "../ContactUs/ContactUsSuccessModal";

const Footer: React.FC = () => {
  const { t } = useTranslation();
  const [openForm, setOpenForm] = React.useState(false);
  const [openSuccess, setOpenSuccess] = React.useState(false);

  const dir = t("css.side") as "rtl" | "ltr";

  const customerCareStyle: CSSProperties = {
    paddingRight: dir === "ltr" ? 16 : 0,
  };

  return (
    <>
      <footer className="footer dark" style={{ direction: dir }}>
        <div className={`footer__logo ${t("css.footerLogoDesign")}`}>
          {t("graphql.languageCode") === "en" ? (
            <EnLogo width={80} height={72} />
          ) : (
            <HeLogo width={80} height={72} />
          )}
        </div>

        <div className="footer__middle-divs">
          <div className="footer__middle-divs__inner-div">
            <span className="footer__middle-divs__title h5-medium">
              {t("footer.About")}
            </span>

            <div className="footer__middle-divs__links">
              <Link
                to="/privacy-policy"
                className="footer__middle-divs__link h6-regular pointer no-link"
              >
                {t("footer.privacyPolicy")}
              </Link>

              <Link
                to="/terms"
                className="footer__middle-divs__link h6-regular pointer no-link"
              >
                {t("footer.termsAndConditions")}
              </Link>
            </div>
          </div>

          <div className="footer__middle-divs__inner-div" />
          <div className="footer__middle-divs__inner-div" />

          <div className={`footer__last-div ${t("css.footerLastDivDesign")}`}>
            <span className="footer__middle-divs__title h5-medium">
              {t("footer.Need Help")}
            </span>

            <div
              className="h6-regular footer__customer-care-link"
              style={customerCareStyle}
              onClick={() => setOpenForm(true)}
            >
              <span>{t("footer.contactUs")}</span>
              <div>
                <ArrowRight />
              </div>
            </div>
          </div>
        </div>
      </footer>
      <ContactUsModal
        open={openForm}
        onClose={() => setOpenForm(false)}
        onSuccess={() => setOpenSuccess(true)}
      />

      <ContactUsSuccessModal
        open={openSuccess}
        onClose={() => setOpenSuccess(false)}
      />
    </>
  );
};

export default Footer;
